import {
  Box,
  Divider,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
} from "@material-ui/core";
import { Button, List } from "@mui/material";
import {
  mdiAccountSupervisor,
  mdiCalendarRange,
  mdiCalendarText,
  mdiCheckboxBlankOutline,
  mdiCheckboxMarked,
  mdiClose,
  mdiCogs,
  mdiDelete,
  mdiDoNotDisturb,
  mdiDownload,
  mdiEye,
  mdiEyeOff,
  mdiFilter,
  mdiFlagTriangle,
  mdiPencil,
  mdiShare,
  mdiViewGridPlus,
  mdiContentCopy,
} from "@mdi/js";
import Icon from "@mdi/react";
import classNames from "classnames";
import React, {
  forwardRef,
  useImperativeHandle,
  useRef,
  useState,
  useContext,
} from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router";
import DeleteProjectModal from "views/ProjectGroupPage/Modals/DeleteProject/index.js";
import EditProjectModal from "views/ProjectGroupPage/Modals/EditProject/index.js";
import ExportTaskGroupData from "views/ProjectGroupPage/RightPart/AllProjectTable/components/ExportTaskGroupData";
import ManageTableData from "./ManageTableData";
import CopyProjectModal from "views/ProjectGroupPage/Modals/CopyProject";
import ShareProjectModal from "components/ShareProjectModal/ShareProjectModal";
import AssignCalendarModal from "components/AssignCalendarModal";
import MemberSetting from "views/ProjectPage/Modals/MembersSetting";
import ProjectSettingModal from "views/ProjectGroupPage/Modals/ProjectSetting";
import { CustomLayoutContext } from "components/CustomLayout";
import CloseIcon from "@mui/icons-material/Close";
import { useDispatch, useSelector } from "react-redux";
import {
  changeVisibleConfigGantt,
  changeVisibleExportPdfDrawer,
} from "actions/system/system";
import { changeVisible } from "actions/gantt";

import { useStyles } from "./styles";

export const pathMonitorEye =
  "M3 4V16H21V4H3M3 2H21C22.1 2 23 2.89 23 4V16C23 16.53 22.79 17.04 22.41 17.41C22.04 17.79 21.53 18 21 18H14V20H16V22H8V20H10V18H3C2.47 18 1.96 17.79 1.59 17.41C1.21 17.04 1 16.53 1 16V4C1 2.89 1.89 2 3 2M10.84 8.93C11.15 8.63 11.57 8.45 12 8.45C12.43 8.46 12.85 8.63 13.16 8.94C13.46 9.24 13.64 9.66 13.64 10.09C13.64 10.53 13.46 10.94 13.16 11.25C12.85 11.56 12.43 11.73 12 11.73C11.57 11.73 11.15 11.55 10.84 11.25C10.54 10.94 10.36 10.53 10.36 10.09C10.36 9.66 10.54 9.24 10.84 8.93M10.07 12C10.58 12.53 11.28 12.82 12 12.82C12.72 12.82 13.42 12.53 13.93 12C14.44 11.5 14.73 10.81 14.73 10.09C14.73 9.37 14.44 8.67 13.93 8.16C13.42 7.65 12.72 7.36 12 7.36C11.28 7.36 10.58 7.65 10.07 8.16C9.56 8.67 9.27 9.37 9.27 10.09C9.27 10.81 9.56 11.5 10.07 12M6 10.09C6.94 7.7 9.27 6 12 6C14.73 6 17.06 7.7 18 10.09C17.06 12.5 14.73 14.18 12 14.18C9.27 14.18 6.94 12.5 6 10.09Z";

const DrawerFilter = forwardRef(
  (
    {
      project = {},
      view = "list",
      disableShowHide,
      isProjectVisible = false,
      isProjectShared = false,
      canUpdateProject = false,
      onOpenFilterKanban = () => {},
      onOpenGranttConfig = () => {},
      onMilestoneClick = () => {},
      onUpdateMember = () => {},
      onUpdateTime = () => {},
      onUpdateVisible = () => {},
      onUpdateSetting = () => {},
      onExportData = () => {},
      onOpenExportData = null,
      onAddColumns = () => {},
      onHideColumn = () => {},
      setItemLocation = () => {},
      onReOrderColumns = () => {},
      onShareProject = () => {},
      onUnShareProject = () => {},
      onChangeSummaryRowStatus = () => {},
      detailStatus = {},
    },
    ref
  ) => {
    const { openSetting, setOpenSetting, settingProps } =
      useContext(CustomLayoutContext);

    const dispatch = useDispatch();
    const classes = useStyles();
    const history = useHistory();
    const [isOpen, setIsOpen] = useState(false);
    const [isOpenEditGroup, setIsOpenEditGroup] = useState(false);
    const [openAlert, setOpenAlert] = useState(false);
    const [openCopy, setOpenCopy] = useState(false);
    const [openShare, setOpenShare] = useState(false);
    const [openCalendar, setOpenCalendar] = useState(false);
    const [openMemberSetting, setOpenMemberSetting] = useState(false);
    const { t } = useTranslation();
    const refManageTableData = useRef(null);
    const refExport = useRef(null);
    const canCopy = detailStatus?.data?.status?.copy;
    const ganntConfig = useSelector(({ gantt }) => gantt?.visible?.gantt);
    const fromNow = ganntConfig?.fromNowLayer;

    useImperativeHandle(ref, () => ({ _toggle: toggleDrawer }));

    const handleOpenGanttDrawer = (state, type) => {
      dispatch(changeVisibleConfigGantt(state, type));
    };
    const handleOpenGanttExport = () => {
      dispatch(changeVisibleExportPdfDrawer(true));
    };
    const handleGanttFromNow = () => {
      localStorage.setItem("gant-fromNowLayer", true);
      dispatch(changeVisible(!fromNow, "gantt", "fromNowLayer"));
    };

    const toggleDrawer = () => {
      setIsOpen(!isOpen);
    };
    const MORE_MENU_ITEMS = {
      list: [
        {
          text: t("PROJECT_LABEL.COLUMNS_MANAGEMENT"),
          icon: mdiViewGridPlus,
          onClick: (e) => {
            refManageTableData.current._toggle();
          },
        },
        {
          text: t("EXPORT_DATA"),
          icon: mdiDownload,
          onClick: (e) => refExport.current._toggle(),
        },
      ],
      kanban: [
        {
          text: t("DATA_FILTER"),
          icon: mdiFilter,
          onClick: (e) => onOpenFilterKanban(),
        },
      ],
      grantt: [
        {
          text: t("DRAWER_FILTER.GANTT.TIME"),
          icon: mdiCalendarRange,
          onClick: (e) => handleOpenGanttDrawer(true, "TIME"),
        },
        {
          text: t("DRAWER_FILTER.GANTT.VIEW"),
          icon: pathMonitorEye,
          onClick: (e) => handleOpenGanttDrawer(true, "COMMON"),
        },
        {
          text: t("DRAWER_FILTER.GANTT.PROCESS"),
          icon: mdiFlagTriangle,
          onClick: (e) => handleGanttFromNow(),
        },
        {
          text: t("DRAWER_FILTER.GANTT.EXPORT"),
          icon: mdiDownload,
          onClick: (e) => handleOpenGanttExport(),
        },
      ],
      chat: [],
      dashboard: [],
      report: [],
    };

    const TITLE_TODO_LIST = {
      list: "List",
      kanban: "Kanban",
      grantt: "Gantt",
    };

    const TODO_LIST =
      MORE_MENU_ITEMS[view].length > 0
        ? {
            title: TITLE_TODO_LIST[view] || "",
            hasDivider: true,
            items: [...MORE_MENU_ITEMS[view]],
          }
        : {};

    const DRAWER_MENU_ITEMS = [
      { ...TODO_LIST },
      {
        title: t("DRAWER_FILTER.BOARD.TITLE"),
        hasDivider: false,
        items: [
          {
            text: t("DRAWER_FILTER.BOARD.EDIT"),
            icon: mdiPencil,
            onClick: (e) => setIsOpenEditGroup(true),
            canDisplay: canUpdateProject,
          },
          {
            text: t("DRAWER_FILTER.BOARD.MEMBER"),
            icon: mdiAccountSupervisor,
            onClick: (e) => {
              setOpenMemberSetting(true);
            },
          },
          {
            text: t("DRAWER_FILTER.BOARD.CALENDAR"),
            icon: mdiCalendarText,
            onClick: (e) => setOpenCalendar(true),
            canDisplay: canUpdateProject,
          },
          {
            text: t("DRAWER_FILTER.BOARD.SETTING"),
            icon: mdiCogs,
            onClick: (e) => onUpdateSetting(),
          },
          {
            text: isProjectVisible
              ? t("DRAWER_FILTER.BOARD.HIDE")
              : t("DRAWER_FILTER.BOARD.SHOW"),
            icon: isProjectVisible ? mdiEyeOff : mdiEye,
            onClick: (e) => !disableShowHide && onUpdateVisible(),
            canDisplay: canUpdateProject,
          },
          {
            text: t("DRAWER_FILTER.BOARD.COPY"),
            icon: mdiContentCopy,
            onClick: (e) => {
              setOpenCopy(true);
            },
            disabled: !canCopy,
          },
          {
            text: !isProjectShared
              ? t("DRAWER_FILTER.BOARD.SHARE")
              : t("DRAWER_FILTER.BOARD.UN_SHARE"),
            icon: !isProjectShared ? mdiShare : mdiDoNotDisturb,
            isDeleteItem: isProjectShared,
            onClick: (e) =>
              !isProjectShared ? handleOpenShare() : onUnShareProject(),
            canDisplay: canUpdateProject,
          },
          {
            text: t("DRAWER_FILTER.BOARD.DELETE"),
            icon: mdiDelete,
            onClick: (e) => _handleDeleteProject(project.id),
            isDeleteItem: true,
            canDisplay: canUpdateProject,
          },
        ],
      },
    ];

    const handleOpenShare = () => {
      setOpenShare(true);
    };

    const _handleDeleteProject = (id) => {
      setOpenAlert(true);
    };

    const _handleDeleted = (id) => {
      if (project)
        history.replace(`/projects?groupID=${project.group_project_id}`);
    };

    return (
      <>
        <Box
          className={
            classNames(classes.drawerWrapper, { isCollapsed: isOpen }) +
            " nav-right-control-action"
          }
        >
          <div className={classes.drawerHeader}>
            <Typography
              variant="h3"
              component="h3"
              style={{ fontSize: 20, fontWeight: 500 }}
            >
              {t("Menu")}
            </Typography>
            {/* <Icon
              path={mdiClose}
              size={1}
              style={{ cursor: "pointer" }}
              onClick={toggleDrawer}
              className="custom-button-hover-round"
            /> */}
            <Button
              sx={{
                borderRadius: "50%",
                background: "#fff",
                padding: "10px",
                minWidth: "auto",
                "&:hover": {
                  background: "#0000000a",
                },
              }}
              onClick={toggleDrawer}
            >
              <CloseIcon sx={{ fill: "#000000" }} />
            </Button>
          </div>

          <List className="nav-right-control-action-body">
            {DRAWER_MENU_ITEMS.map((item, index) => (
              <GroupFilter key={index} {...item} />
            ))}
          </List>
        </Box>

        <DeleteProjectModal
          open={openAlert}
          setOpen={setOpenAlert}
          projectGroupId={project?.id}
          selectedProject={project}
          doAfterSuccess={_handleDeleted}
        />
        <EditProjectModal
          open={isOpenEditGroup}
          setOpen={setIsOpenEditGroup}
          {...{ curProject: project }}
        />
        <ExportTaskGroupData
          ref={refExport}
          onExportData={onExportData}
          projectId={project?.id}
        />
        <ManageTableData
          ref={refManageTableData}
          onReOrderColumns={onReOrderColumns}
          onAddColumns={onAddColumns}
          onHideColumn={onHideColumn}
          setItemLocation={setItemLocation}
          onChangeSummaryRowStatus={onChangeSummaryRowStatus}
          canEdit={canUpdateProject}
        />
        <CopyProjectModal
          open={openCopy}
          setOpen={setOpenCopy}
          projectGroupId={project?.id}
          projectGroupName={project?.name}
        />

        <ShareProjectModal
          openModal={openShare}
          setopenModal={setOpenShare}
          projectId={project ? project.id : null}
        />

        {openCalendar && (
          <AssignCalendarModal
            openModal={openCalendar}
            setopenModal={setOpenCalendar}
          />
        )}
        {openMemberSetting && (
          <MemberSetting
            open={openMemberSetting}
            setOpen={setOpenMemberSetting}
            canEdit={canUpdateProject}
            project_id={project.id}
            project={project}
          />
        )}

        {openSetting && (
          <ProjectSettingModal
            open={openSetting}
            setOpen={setOpenSetting}
            {...settingProps}
          />
        )}
      </>
    );
  }
);

const GroupFilter = React.memo(({ title, hasDivider = false, items = [] }) => {
  return (
    <>
      <p style={{ padding: "0 16px", color: "#666", fontSize: 14 }}>{title}</p>
      {items.map((item, index) => (
        <ItemMenuFilter key={index} {...item} />
      ))}
      {hasDivider && <Divider />}
    </>
  );
});

const ItemMenuFilter = ({
  text,
  icon,
  subText,
  valueSearch,
  canDisplay = true,
  isSearchItem = false,
  isCheckType = false,
  isActive = false,
  isDeleteItem = false,
  onClick = () => {},
  onSearch = () => {},
  disabled,
}) => {
  const classes = useStyles();

  if (!canDisplay) return null;
  if (isSearchItem)
    return (
      <ItemSearch
        text={text}
        icon={icon}
        onClick={onClick}
        valueSearch={valueSearch}
        onSearch={onSearch}
      />
    );

  return (
    <>
      <ListItem
        button
        className={classes.menuItem}
        onClick={(e) => onClick(e)}
        disabled={disabled}
      >
        <ListItemIcon className={classes.menuIcon}>
          {isActive ? (
            <Icon path={mdiCheckboxMarked} color="#11A159" size={1} />
          ) : (
            <Icon
              path={isCheckType ? mdiCheckboxBlankOutline : icon}
              size={1}
            />
          )}
        </ListItemIcon>
        <div className={classes.menuTextWrapper}>
          <ListItemText
            className={classNames(classes.menuText, {
              "is-delete": isDeleteItem,
            })}
            primary={text}
          />
          <Typography>{subText}</Typography>
        </div>
      </ListItem>
    </>
  );
};

const ItemSearch = ({ icon, valueSearch, text, onSearch = () => {} }) => {
  const classes = useStyles();

  const [isFocus, setIsFocus] = useState(false);
  const refInput = useRef(null);

  const _handleFocus = () => {
    setIsFocus(true);
    setTimeout(() => {
      refInput.current.focus();
    }, 0);
  };

  const _handleBlur = () => {
    if (!refInput.current.value.length) {
      setIsFocus(false);
    }
  };

  return (
    <ListItem button className={classes.menuItem} onClick={_handleFocus}>
      <ListItemIcon className={classes.menuIcon}>
        <Icon path={icon} size={1} />
      </ListItemIcon>
      <div className={classes.menuTextWrapper}>
        {isFocus ? (
          <>
            <input
              ref={refInput}
              type="text"
              className={classes.inputSearch}
              placeholder="Nhập nội dung cần tìm"
              onBlur={_handleBlur}
              value={valueSearch}
              onChange={onSearch}
              style={{
                border: 0,
                background: "transparent",
                outline: "none",
                height: 25,
              }}
            />
          </>
        ) : (
          <ListItemText className={classes.menuText} primary={text} />
        )}
      </div>
    </ListItem>
  );
};

export default DrawerFilter;
